import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/gdpr")({
  head: () => seoMeta({
    title: "Conformità GDPR di LexAIPro",
    description: "Come LexAIPro rispetta il Regolamento UE 2016/679 sul trattamento dei dati personali.",
    path: "/gdpr",
  }),
  component: () => (
    <ContentPage
      eyebrow="Conformità"
      title="Conformità GDPR"
      lead="Trattiamo i dati personali secondo il Regolamento UE 2016/679. Sei titolare del trattamento sui dati dei tuoi clienti; LexAIPro è responsabile del trattamento."
      breadcrumbs={[{name:"Home",path:"/"},{name:"GDPR",path:"/gdpr"}]}
      sections={[
        { heading: "Ruoli", body: "Tu (avvocato/studio) sei Titolare del trattamento. LexAIPro è Responsabile del trattamento ai sensi dell'art. 28 GDPR. Stipuliamo un DPA su richiesta." },
        { heading: "Diritti degli interessati", bullets: ["Accesso, rettifica, cancellazione","Limitazione e opposizione","Portabilità","Reclamo al Garante"] },
        { heading: "Sub-responsabili", body: "Elenco aggiornato disponibile su richiesta. Tutti i sub-responsabili sono in UE o coperti da clausole contrattuali standard." },
      ]}
      cta={{ label: "Richiedi DPA", to: "/contatti" }}
      heroImage={pickContent(30)}
      updated="2026"
    />
  ),
});
